import React from "react";
import { IconEdit } from "@tabler/icons-react";
import { type ApiKey } from "utils/types/api_keys.type";
import { formatRelativeTime, maskValue, copyToClipboard } from "../utils";

interface ApiKeyTableRowProps {
  apiKey: ApiKey;
  isSuperAdmin: boolean;
  onEdit: () => void;
}

export const ApiKeyTableRow: React.FC<ApiKeyTableRowProps> = ({
  apiKey,
  isSuperAdmin,
  onEdit,
}) => {
  return (
    <tr className="bg-black-300 hover:bg-black-400 transition-colors">
      <td className="py-4 px-5 rounded-l-lg">
        <p className="text-black-900 text-sm font-medium">
          {apiKey.label}
        </p>
      </td>
      <td className="py-4 px-5">
        <div className="flex items-center gap-2">
          <p className="text-black-900 text-sm font-mono">
            {apiKey.key}
          </p>
          <button
            onClick={() => {
              void copyToClipboard(apiKey.key);
            }}
            className="text-cyan-800 hover:text-cyan-800/80 text-xs"
            title="Copy key"
          >
            Copy
          </button>
        </div>
      </td>

      <td className="py-4 px-5">
        {
          apiKey.value ?
            <div className="flex items-center gap-2">
              <p className="text-black-900 text-sm font-mono max-w-xs truncate">
                {maskValue(apiKey.value)}
              </p>

              <button
                onClick={() => {
                  void copyToClipboard(apiKey.value);
                }}
                className="text-cyan-800 hover:text-cyan-800/80 text-xs"
                title="Copy value"
              >
                Copy
              </button>
            </div>
            :
            <p className="text-black-500 select-none text-sm font-mono max-w-xs truncate">
              No value set
            </p>
        }
      </td>
      <td className="py-4 px-5">
        <p className="text-black-900 text-sm">
          {formatRelativeTime(apiKey.createdAt)}
        </p>
      </td>
      <td className="py-4 px-5">
        <p className="text-black-900 text-sm">
          {formatRelativeTime(apiKey.updatedAt)}
        </p>
      </td>
      {isSuperAdmin && (
        <td className="py-4 px-5 rounded-r-lg">
          <div className="flex items-center justify-center gap-2">
            <button
              onClick={onEdit}
              className="text-cyan-800 hover:text-cyan-800/80 transition text-sm font-medium px-3 py-1 rounded hover:bg-cyan-300/20"
              title="Edit API key"
            >
              <IconEdit size={18} />
            </button>
          </div>
        </td>
      )}
    </tr>
  );
};

